import React, { useEffect, useState } from 'react';
import DatePicker from 'material-ui/DatePicker';
import moment from 'moment';

const fromMinDate = moment([2017, 10, 3]).toDate();
const untilMaxDate = moment().toDate();

export default function RangeDates({
    from, until, modifyFrom, modifyUntil, 
}) {
    const [fromMaxDate, _setFromMaxDate] = useState(until);
    const [untilMinDate, _setUntilMinDate] = useState(from);
    const [fromDate, setFromDate] = useState(from);
    const [untilDate, setUntilDate] = useState(until);

    useEffect(() => {
        _setFromMaxDate(until); 
        _setUntilMinDate(from);
        setFromDate(from);
        setUntilDate(until);
    }, [from, until]);

    return (
        <div className='row'>
            <div className='col-xs-6'>
                <DatePicker
                    floatingLabelText='From'
                    autoOk
                    minDate={fromMinDate}
                    maxDate={fromMaxDate}
                    onChange={(_e, d) => modifyFrom(d)}
                    value={fromDate}
                    formatDate={date => moment(date).format('MM-DD-YYYY')}
                />
            </div>
            <div className='col-xs-6'>
                <DatePicker
                    floatingLabelText='Until'
                    autoOk
                    minDate={untilMinDate}
                    maxDate={untilMaxDate}
                    onChange={(_e, d) => modifyUntil(d)}
                    value={untilDate}
                    formatDate={date => moment(date).format('MM-DD-YYYY')}
                />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Statistics/Composition/RangeDates.jsx